import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import SocialLink from './SocialLink';
import ShareIcon from './icon/ShareIcon';
import translate from '../translate';
import { useModal } from '../../services/customHooks';
import ShareModal from '../../sections/academy/modal/ShareModal';
import ShareLinkProps, { SHARE_LINKS } from './propTypes/shareLinkProps';

const shareLinkInitState = {
  show: false,
  data: null,
};

function SocialLinks(props) {
  const { t, linksOptions, orientation } = props;
  const [shareLinkModal, setShowShareLinkModal] = useModal(shareLinkInitState);

  const linksList = useMemo(
    () =>
      linksOptions?.map(linkOpt => {
        const finalOption = linkOpt;
        switch (finalOption.key) {
          case SHARE_LINKS.SHARE_LINK:
          default:
            finalOption.icon = <ShareIcon />;
            break;
        }
        return finalOption;
      }),
    [],
  );
  const handleClick = useCallback(
    link => {
      const key = link.key?.toLowerCase();
      switch (key) {
        case SHARE_LINKS.SHARE_LINK:
        default:
          setShowShareLinkModal({
            show: true,
            data: { marketProductId: link?.marketProductId },
          });
          break;
      }
    },
    [setShowShareLinkModal],
  );

  return (
    <>
      {shareLinkModal?.show && (
        <ShareModal
          url=""
          onClose={() => setShowShareLinkModal(shareLinkInitState)}
          t={t}
          marketProductId={shareLinkModal?.data?.marketProductId}
        />
      )}
      <div className={`social-links-list ${orientation}`}>
        {linksList.map(link => (
          <SocialLink key={link.key} onClick={() => handleClick(link)}>
            {link.icon}
          </SocialLink>
        ))}
      </div>
    </>
  );
}

SocialLinks.propTypes = {
  t: PropTypes.func.isRequired,
  orientation: PropTypes.string,
  linksOptions: PropTypes.shape(ShareLinkProps.propType),
};

SocialLinks.defaultProps = {
  orientation: 'horizontal',
  linksOptions: [],
};

export default translate(SocialLinks);
